import { atom } from 'recoil';

export type onBoardState = {
  step: number;
  feature?: '기본기능' | '신규회원창출기능' | '';
};

export const onBoardStateAtom = atom<onBoardState>({
  key: 'on_board_state',
  default: {
    step: 1,
    feature: ''
  }
});
